var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6871 13.6449C21.159 14.1168 21.159 14.8819 20.6871 15.3538L13.4371 22.6038C12.9652 23.0757 12.2001 23.0757 11.7283 22.6038C11.2564 22.1319 11.2564 21.3668 11.7283 20.8949L18.1238 14.4993L11.7283 8.10377C11.2564 7.63189 11.2564 6.86681 11.7283 6.39493C12.2001 5.92304 12.9652 5.92304 13.4371 6.39493L20.6871 13.6449Z",
    fill: "#00002F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.553a513695ff02b6152b9a7a792ca5ee.svg";
export { ForwardRef as ReactComponent };